<template>
    <div v-zoezi-editable="{prop: 'html', html: true, multiline: true}" v-html="sanitizedHtml"></div>
</template>

<script>
import { sanitizeHtml } from '../plugins/safeHtml.js';
// Renders sanitized static HTML only (no runtime Vue template/component
// evaluation). Do NOT reintroduce v-runtime-template here — it would re-open
// the XSS hole this component was changed to close.
export default {
    name: 'zoezi-html',

    zoezi: {
        title: 'Html',
        icon: 'mdi-code-tags'
    },

    props: {
        html: {
            title: 'HTML text',
            type: String,
            fulltype: 'html',
            default:
                `<div class="fill-height zoezi-html-default">
  <h3>Html-text</h3>
</div>`
        }
    },
    computed: {
        sanitizedHtml() {
            return sanitizeHtml(this.html);
        }
    },
    data: () => ({
    })
}
</script>
